export const ACTION_INCREASE = 'increase';
export const ACTION_DECREASE = 'decrease';
export const TYPE_CURRENCY = 'amount';
export const TYPE_PERCENT = 'percent';
export const SET_AMOUNT = 'setAmount';
export const UPDATE_AMOUNT = 'updatedAmount';
